<template>
  <section>
    <v-form ref="formSubirArchivo" @submit.prevent="SubirArchivo">
      <v-layout row>
        <v-flex xs12 md2 class="text-h4 mb-3 primary--text font-weight-medium text-uppercase text-center" >
         archivo RAR
        </v-flex>
        <v-flex xs12 md3 pl-3>
          <input
            accept=".rar"
            type="file"
            v-show="false"
            ref="uploadRAR"
            @change="subirArchivo($event)"
          />
          <v-btn
            medium
            color="primary"
            @click.prevent="subirRAR"
            class="mr-3"
          >
            <v-icon>file_upload</v-icon> Seleccionar
          </v-btn>
        </v-flex>
        
      </v-layout>
    </v-form>
    
    <v-layout row wrap class="mt-2">
      
      <v-flex xs12 md12>
        <v-card>
          <v-card-text>
           
            <v-simple-table fixed-header height="61vh">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left primary--text">
                      RFC Empresa
                    </th>
                    <th class="text-left primary--text">
                      RFC Trabajador
                    </th>
                    <th class="text-left primary--text">
                      Nombre
                    </th>
                    <th class="text-left primary--text">
                      Periodo
                    </th>
                    <th class="text-left primary--text">
                      PDF
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!recibos.length">
                  <td colspan="5">
                    <div class="ma-3">
                      Archivo sin procesar...
                    </div>
                  </td>
                </tbody>
                <tbody v-else>
                  <template v-for="recibo in recibos">
                    <tr :key="recibo.ReciboID">
                      <td>{{ recibo.Emisor_RFC }}</td>
                      <td>{{ recibo.Receptor_RFC}}</td>
                      <td>{{ recibo.Receptor_Nombre }}</td>
                      <td>{{ recibo.Periodo }}</td>
                      <td>
                         <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              @click.prevent="verArchivo(recibo.PDF)"
                            >
                              <v-icon color="primary">mdi-file-pdf-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver PDF</span>
                        </v-tooltip>  
                      </td>                     
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <span class="ml-3">
          <span class="primary--text font-weight-bold">REGISTROS:</span>
          {{ registros }}
        </span>
        </v-card-actions>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import ServicioUpload from "../services/upload";

export default {
  name: "Recibos",
  data() {
    return {
      recibos: [],
      registros: 0,
      mostrarCambioPassword: false,
    };
  },
  computed: {
    
  },
  mounted() {
    this.ready = true;
    
  },
  methods: {
  
    async subirArchivo(ev) {
      //recibos = null;
      if (ev.target.files.length) {
        const archivo = ev.target.files[0];
        const res = await ServicioUpload.uploadRAR(archivo);
        if (res.data.result === 1) {
          this.recibos = res.data.data.Table0;
          this.registros = this.recibos.length;
        } else {
          this.$root.mensajeError =
            res.data.message || "Error al subir el archivo.";
          this.registros = 0;
        }
      }
      this.$refs.uploadRAR.value = null;
    },
    subirRAR() {
      this.$refs.uploadRAR.click();
    },
    async verArchivo(archivo) {
      window.open(this.config.RutaRecibos + archivo, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>
